/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';
import * as elementActions from '../../redux/actions/elements';
import * as productActions from '../../redux/actions/product';
import * as userActions from '../../redux/actions/user';
import * as orderRepo from '../../shared/repos/graphql/order';

import MediumProduct from './MediumProduct/MediumProduct';
import MediumProductRebrand from './MediumProductRebrand/MediumProductRebrand';
import SmallProduct from './SmallProduct/SmallProduct';

import DeliveryPickUpWidget from '../DeliveryPickUpWidget/DeliveryPickUpWidget';
import Loader from '../Loader/Loader';

import styles from './ProductCard.module.css';

// CONSTANTS
import { defaultCurrency } from '../../shared/constants/currency';
import endpoints from '../../shared/constants/endpoints';
import { orderMethods } from '../../shared/constants/order';

// UTILITIES
import * as productRepo from '../../shared/repos/graphql/product';
import { guardOrderChange } from '../../shared/utilities/orders';
import * as tagmanagerEvents from '../../shared/utilities/tagmanagerEvents';
import { isMobile, routeCountryPath } from '../../shared/utilities/common';
import { openOrderUpdateFailModal } from '../../shared/utilities/modals';
import amplitudeAnalytics, {
  formatAmplitudeSuggestedItemCategory,
  getAmplitudeSuggestedItemPageNameForProductCard,
} from '../../shared/utilities/amplitude';
import { isBrandRefreshEnabled } from '../../shared/utilities/brandRefresh';

import { FEATURED_PRODUCT_TYPE_CART, FEATURED_PRODUCT_TYPE_DETAIL } from '../../shared/constants/product';
import { getCartErrorMessage } from '../../shared/utilities/cart';


const oneIcon = require('./imgs/plus.svg');
const manyIcon = require('./imgs/many.svg');
const brandRefreshCaretIcon = require('./imgs/brand-refresh-caret-right.svg');
const brandRefreshPlusIcon = require('./imgs/brand-refresh-plus.svg');
const brandRefreshOneIcon = require('../../pages/UpsellProduct/imgs/brand-refresh-plus.svg');
const brandRefreshManyIcon = require('../../pages/UpsellProduct/imgs/brand-refresh-many.svg');

class ProductCard extends Component {

    constructor(props) {
        super(props);

        this.state = {
            updateCartLoading: false,
            isUpsellFeaturedRunning: false
        };
        this.productCardElement = React.createRef();
    }

    componentDidMount = () => {
      window.addEventListener('scroll', this.handleScroll)
    }

    handleScroll = () => {
      if(isMobile()) {
        const rect = this.productCardElement.current.getBoundingClientRect();
        if (rect.top >= 100 && rect.left >= 0 && rect.bottom <= window.innerHeight - 100 && rect.right <= window.innerWidth) {
          // Track active section for potential future use
        }
      }
    }

    componentWillUnmount = () => {
      window.removeEventListener('scroll', this.handleScroll)
    }


    className = () => {

        const { isBox, isCustom } = this.props;

        if (isBox) {
            return 'productCard--box';
        }

        if (isCustom) {
            return 'productCard--customizable';
        }

        return 'productCard--simple';
    }

    onClick = (event) => {
        if (event) {
          if (typeof event.preventDefault === 'function') {
            event.preventDefault();
          }
          if (typeof event.stopPropagation === 'function') {
            event.stopPropagation();
          }
        }
        const { history, id, upsellFeatured, userCartId, isUpsale, productSlug } = this.props;
        const { isUpsellFeaturedRunning } = this.state;
        if (upsellFeatured && !isUpsellFeaturedRunning) {
          this.setState({
              isUpsellFeaturedRunning: true
          });
          this.addUpsellFeatured(userCartId,id,FEATURED_PRODUCT_TYPE_DETAIL);
        }

        this.trackClickProductCard();

        let path = `/products/${productSlug}`;

        if (isUpsale) {
            path += '?isUpsale=true';
        }

        return history.push(routeCountryPath(path));
    }

    getAmplitudeProductType = () => {
      const { isBox, isCustom } = this.props;
      return isBox || isCustom ? 'Customizeable' : 'Non-customizable';
    }

    trackClickProductCard = () => {
      const { amplitudeProductCardContext, id, title } = this.props;
      if (!amplitudeProductCardContext?.pageName) {
        return;
      }
      amplitudeAnalytics.trackClickProductCard({
        pageName: amplitudeProductCardContext.pageName,
        productCategory: amplitudeProductCardContext.productCategory,
        productName: title,
        productId: id,
        productType: this.getAmplitudeProductType(),
      });
    }

    onAdd = async e => {
      const {
        isBox,
        isCustom,
        id,
        userCartId,
        setUserCart,
        afterProductAdded,
        selectedStore,
        setModalObject,
        price,
        title,
        categories,
        upsellFeatured,
        setUpsellProductModalActive,
        isUpsale,
        location,
        currency,
      } = this.props;

      e.stopPropagation();
      
      // Store the triggering element for focus return
      const triggeringElement = e.currentTarget;

      if (upsellFeatured) {
        let type = FEATURED_PRODUCT_TYPE_CART;
        if (isBox || isCustom) {
          type = FEATURED_PRODUCT_TYPE_DETAIL;
        }
        this.addUpsellFeatured(userCartId,id,type);
      }
      if (isBox || isCustom) {
        const { data } = await productRepo.getProduct(id);
        const {product} = data;
        setUpsellProductModalActive({
          openModal: true, 
          product, 
          item: data,
          triggeringElement
        })
        return;
      }

      if (!selectedStore) {
        // eslint-disable-next-line
        return setModalObject({
            fullscreenChildren: true,
            children: (
              <DeliveryPickUpWidget
                isModal
                productId={id}
                analyticsPageSection="Product Image"
              />
            )
        });
      }

      this.setState({
        updateCartLoading: true
      });

      try {
        await orderRepo.addProductToOrderV2(
          userCartId,
          { product: id },
          ({ data }) => {
            const localStorageCart = data?.order?.items?.map((item) => {
              return item;
            });

            if (localStorageCart) {
              setUserCart(localStorageCart);
            }

            tagmanagerEvents.addToCart({
              id,
              title,
              price,
              categories,
              quantity: 1
            });
          },
          {
            pathname: location?.pathname,
            source: 'product_card',
            enrichmentProduct: { id, title, price, categories },
            isBox,
            isCustom,
            currencySymbol: currency?.symbol || '$',
          },
        );

        if (isUpsale) {
          const pageName = getAmplitudeSuggestedItemPageNameForProductCard(location?.pathname);
          if (pageName) {
            amplitudeAnalytics.trackAddSuggestedItem({
              pageName,
              productCategory: formatAmplitudeSuggestedItemCategory(categories),
              productName: title,
              productId: id,
            });
          }
        }

        if (afterProductAdded) {
          afterProductAdded();
        }
      } catch (reason) {
        const message = getCartErrorMessage(reason);
        setModalObject(openOrderUpdateFailModal(message, () => setModalObject(null)));
      } finally {
        this.setState({
          updateCartLoading: false
        });
      }
      // eslint-disable-next-line
      return null;
    };

    setStateDispatchers = () => {
      const { setModalObject} = this.props;
      setModalObject(null);
    }

    addUpsellFeatured = async (userCartId, productId, type) => {
        await orderRepo.addProductToUpsellFeatured(userCartId, { productId: parseInt(productId,10), type });
        this.setState({
            isUpsellFeaturedRunning: false
        });
    }

    showDoughProCardOverlay = () => {
      const {
        categories,
        doughProSpecialCategory,
        doughProMember,
        isBetaCustomer,
        isDoughProActive
      } = this.props;
      if (!doughProSpecialCategory || !(isBetaCustomer || isDoughProActive)) {
        return false;
      }

      const { slug } = doughProSpecialCategory;

      if (!categories || categories.length === 0) {
        return false;
      }

      const slugs = categories.map((category) => category.slug ? category.slug.toLowerCase() : category.slug);

      if (slugs.indexOf(slug.toLowerCase()) === -1) {
        return false;
      }

      if (!doughProMember) {
        return true;
      }

      return !doughProMember.active;
    }

    render() {
        const {
          type,
          id,
          title,
          price,
          strikePrice,
          primaryImage,
          secondaryImage,
          isBox,
          isCustom,
          isLimited,
          description,
          alternate,
          history,
          userOrderMethod,
          calories,
          currency,
          oos,
          productSlug,
          discountPercent,
          categories,
          brandRefreshSuggested,
          isCrossSell,
        } = this.props;

        const { updateCartLoading } = this.state;

        const formattedPrice = price ? parseFloat(price).toFixed(2) : 0;
        const needsChooseFlow = isBox || isCustom;

        let smallProductIcon;
        if (isCrossSell) {
          smallProductIcon = needsChooseFlow ? brandRefreshManyIcon : brandRefreshOneIcon;
        } else if (brandRefreshSuggested) {
          smallProductIcon = needsChooseFlow ? brandRefreshCaretIcon : brandRefreshPlusIcon;
        } else {
          smallProductIcon = needsChooseFlow ? manyIcon : oneIcon;
        }

        const currentOrderNotDoughPro = userOrderMethod ? userOrderMethod !== orderMethods.doughPro : false;

        const productByType = {
            small: (
              <SmallProduct
                id={id}
                onClick={this.onClick}
                onAdd={e => this.onAdd(e)}
                title={title}
                price={formattedPrice}
                strikePrice={strikePrice}
                image={primaryImage}
                icon={smallProductIcon}
                className={this.className()}
                doughProOverlay={this.showDoughProCardOverlay()}
                calories={calories}
                currency={currency}
                categories={categories}
                description={description}
                brandRefreshSuggested={brandRefreshSuggested}
                isCrossSell={isCrossSell}
              />
            ),
            medium: isBrandRefreshEnabled() ? (
              <MediumProductRebrand
                id={id}
                onAdd={e => this.onAdd(e)}
                primaryImage={primaryImage}
                secondaryImage={secondaryImage}
                price={formattedPrice}
                strikePrice={strikePrice}
                title={title}
                onClick={this.onClick}
                isLimited={isLimited}
                description={description}
                alternate={alternate}
                icon={isBox || isCustom ? manyIcon : oneIcon}
                className={this.className()}
                doughProOverlay={this.showDoughProCardOverlay()}
                calories={calories}
                currency={currency}
                isSingle={!(isBox || isCustom)}
                oos={oos}
                productSlug={productSlug}
                discountPercent={discountPercent}
                isLoading={updateCartLoading}
              />
            ) : (
              <MediumProduct
                id={id}
                onAdd={e => this.onAdd(e)}
                primaryImage={primaryImage}
                secondaryImage={secondaryImage}
                price={formattedPrice}
                strikePrice={strikePrice}
                title={title}
                onClick={this.onClick}
                isLimited={isLimited}
                description={description}
                alternate={alternate}
                icon={isBox || isCustom ? manyIcon : oneIcon}
                className={this.className()}
                doughProOverlay={this.showDoughProCardOverlay()}
                calories={calories}
                currency={currency}
                isSingle={!(isBox || isCustom)}
                oos={oos}
                productSlug={productSlug}
                discountPercent={discountPercent}
              />
            )
        };

        const overlayStyles = {
          small: styles.productCardOverlaySmall,
          medium: styles.productCardOverlay,
        };

        const isSuggestedCard = Boolean(brandRefreshSuggested || isCrossSell);

        return (
          <div
            data-ddog-id="product_card"
            data-part={isCrossSell ? 'cross-sell-card-wrap' : undefined}
            className={`
          ${type === 'medium' ? 'h-auto' : ''}
          text-dark dark:text-white
          ${styles.productCardWrapper}
          ${isCrossSell ? styles.productCardCrossSell : ''}
          ${this.showDoughProCardOverlay() ? styles.productCardLocked : ''}
          `}
            ref={this.productCardElement}
            role={isSuggestedCard ? undefined : 'button'}
            tabIndex={isSuggestedCard ? undefined : 0}
            onClick={isSuggestedCard ? undefined : this.onClick}
            onKeyDown={isSuggestedCard ? undefined : (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                this.onClick();
              }
            }}
            aria-label={isSuggestedCard ? undefined : `${title} - ${price} - Click to view details`}
          >
            { this.showDoughProCardOverlay() ? (
              <div
                className={`${overlayStyles[type]} ${alternate ? styles.productCardOverlayAlternate : ''}`}
                onClick={() => guardOrderChange(currentOrderNotDoughPro, history.push, routeCountryPath(endpoints.doughProPage))}
              />
            ) : null}

            {updateCartLoading && !isBrandRefreshEnabled() ? (
              <div className={styles.loaderWrapper}>
                <Loader height={40} />
              </div>
            ) : null}
            {oos === 1
              ? (
                <div className="absolute right-2 top-2 h-[75px] w-[75px] text-center rounded-full text-[12px] flex justify-center items-center z-10 text-white dark:text-dark bg-dark dark:bg-light">
                  <span>
BE
                    <br />
BACK
                    <br />
SOON!
                  </span>
                </div>
)
              : null}
            {productByType[type]}
          </div>
        );
    }
};

ProductCard.propTypes = {
    type: PropTypes.string.isRequired,
    primaryImage: PropTypes.node.isRequired,
    price: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    isLimited: PropTypes.bool,
    description: PropTypes.string,
    alternate: PropTypes.bool,
    isBox: PropTypes.bool,
    isCustom: PropTypes.bool,
    isUpsale: PropTypes.bool,
    isCrossSell: PropTypes.bool,
    id: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    categories: PropTypes.arrayOf(PropTypes.shape({
      slug: PropTypes.string.isRequired
    })).isRequired,
    afterProductAdded: PropTypes.func,
    history: PropTypes.shape({
        push: PropTypes.func.isRequired
    }).isRequired,
    location: PropTypes.shape({
        pathname: PropTypes.string,
        search: PropTypes.string,
    }),
    userOrderMethod: PropTypes.string,
    isBetaCustomer: PropTypes.bool,
    isDoughProActive: PropTypes.bool,
    upsellFeatured: PropTypes.bool,
    calories: PropTypes.string,
    currency: PropTypes.objectOf(PropTypes.string),
    oos: PropTypes.number,
    discountPercent: PropTypes.number,
    brandRefreshSuggested: PropTypes.bool,
    amplitudeProductCardContext: PropTypes.shape({
      pageName: PropTypes.string,
      productCategory: PropTypes.string,
    }),
};

ProductCard.defaultProps = {
    location: { pathname: '', search: '' },
    isLimited: false,
    isUpsale: false,
    isCrossSell: false,
    description: null,
    alternate: false,
    isBox: false,
    isCustom: false,
    id: '',
    afterProductAdded: null,
    userOrderMethod: null,
    isBetaCustomer: false,
    isDoughProActive: false,
    upsellFeatured: false,
    calories: null,
    currency: defaultCurrency,
    oos: null,
    discountPercent: 0,
    brandRefreshSuggested: false,
    amplitudeProductCardContext: null,
};

export const mapDispatchToProps = (dispatch) => ({
    setUserCart: (value) => dispatch(userActions.setUserCart(value)),
    setModalObject: (value) => dispatch(elementActions.setModalObject(value)),
    setUpsellProductModalActive: (value) => dispatch(productActions.setUpsellProductModalActive(value))
});

export const mapStateToProps = (state) => {
    const {
        selectedStore,
        userOrderMethod,
        userCart,
        userAddress,
        userCartId,
        doughProMember,
        isBetaCustomer
    } = state.user;
    const {
      doughProSpecialCategory
    } = state.elements;
    const {
      isDoughProActive
    } = state.doughPro;
    const {
        isCaloriesActive
    } = state.product
    const { currency } = state.currency;
    return {
        selectedStore,
        userOrderMethod,
        userCart,
        userAddress,
        userCartId,
        doughProMember,
        doughProSpecialCategory,
        isBetaCustomer,
        isDoughProActive,
        isCaloriesActive,
        currency
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProductCard));
